import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'
import { SubTabs, SubTab } from 'components/layout'
import {
  TasksAjPreparationTrainingsTable,
  TasksAjParticipantEventsTable
} from 'components/sections/tasks'
import { meta, tableCommon } from 'helpers/decorators'
import { apiTasksAj, apiAjEvents, apiAwards } from 'helpers/decorators/api'
import { modal } from 'redux/modules/app'
import { AJ_EVENT_TYPES } from 'constants/enums'

@meta({
  title: 'Tasks - Adventurous Journey',
  intlKey: 'pageTitle.tasks_aj'
})
@apiTasksAj({
  tasks: true,
  events: true,
  preparation: true,
  useCommonLimit: true
})
@apiAwards({
  updatePreparationTasks: true
})
@apiAjEvents()
@tableCommon()
@connect(null, { modal })
class TasksAj extends Component {
  static propTypes = {
    tasksAjEvents: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    approveAjEventParticipant: PropTypes.func.isRequired,
    returnAjEventParticipant: PropTypes.func.isRequired,
    setTasksAjPrepParams: PropTypes.func.isRequired,
    setTasksAjParticipantEventsParams: PropTypes.func.isRequired,
    approveAjPreparationTraining: PropTypes.func.isRequired,
    returnAjPreparationTraining: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func
  }

  render() {
    const {
      tasksAjEvents,
      approveAjEventParticipant,
      returnAjEventParticipant,
      setTasksAjPrepParams,
      setTasksAjParticipantEventsParams,
      approveAjPreparationTraining,
      returnAjPreparationTraining,
      setCommonLimit
    } = this.props
    const { list } = tasksAjEvents.participantEvents

    // const preparationTasks = list.filter(item => get(item, 'ajParticipantEvent.ajEvent.ajEventCategory.value') === AJ_EVENT_TYPES.preparation.id)
    const practiceTasks = list.filter(
      item =>
        get(item, 'ajParticipantEvent.ajEvent.ajEventCategory.value') ===
        AJ_EVENT_TYPES.practice.id
    )
    const qualificationTasks = list.filter(
      item =>
        get(item, 'ajParticipantEvent.ajEvent.ajEventCategory.value') ===
        AJ_EVENT_TYPES.qualification.id
    )

    return (
      <SubTabs>
        <SubTab
          title="Preparation"
          intlKey="aj.preparation"
          progress={tasksAjEvents.preparationAndTraining.list.length}
        >
          <TasksAjPreparationTrainingsTable
            tasks={tasksAjEvents.preparationAndTraining}
            list={tasksAjEvents.preparationAndTraining.list}
            setCommonLimit={setCommonLimit}
            approveModal={approveAjPreparationTraining}
            returnModal={returnAjPreparationTraining}
            modal={this.props.modal}
            setParams={setTasksAjPrepParams}
          />
        </SubTab>
        <SubTab
          title="Practice"
          intlKey="aj.practice"
          progress={practiceTasks.length}
        >
          <TasksAjParticipantEventsTable
            tasks={tasksAjEvents.participantEvents}
            list={practiceTasks}
            setCommonLimit={setCommonLimit}
            approveModal={approveAjEventParticipant}
            returnModal={returnAjEventParticipant}
            modal={this.props.modal}
            setParams={setTasksAjParticipantEventsParams}
          />
        </SubTab>
        <SubTab
          title="Qualifying"
          intlKey="aj.qualifying"
          progress={qualificationTasks.length}
        >
          <TasksAjParticipantEventsTable
            tasks={tasksAjEvents.participantEvents}
            list={qualificationTasks}
            setCommonLimit={setCommonLimit}
            approveModal={approveAjEventParticipant}
            returnModal={returnAjEventParticipant}
            modal={this.props.modal}
            setParams={setTasksAjParticipantEventsParams}
          />
        </SubTab>
      </SubTabs>
    )
  }
}

export default TasksAj
